import cnBind from "classnames/bind";
import type { ContentSatus } from "@/entities/types/entities";
import { CustomImage } from "@/shared/ui/CustomImage";
import styles from "./CaseCard.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    id: string;
    number?: number;
    title?: string;
    description?: string;
    categoryName?: string;
    status: ContentSatus;
    image: string;
};

export const CaseCard = ({ description, title, image }: Props) => {
    return (
        <div className={cx("case-card")}>

            {/* 1. Картинка должна находиться СТРОГО внутри этого контейнера */}
            <div className={cx("image-container")}>
                <CustomImage
                    className={cx("image")}
                    src={image}
                    alt={title || "case image"}
                    fill
                    sizes="(max-width: 768px) 280px, 257px"
                />
            </div>

            {/* 2. Текстовый блок находится НА ОДНОМ УРОВНЕ с image-container, а не внутри него */}
            <div className={cx("text")}>
                <h3>{title}</h3>
                <p>{description}</p>
            </div>

        </div>
    );
};
